import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { ICON_SPRITE_PATH } from '../../../config/paths';

export const IconSource = {
  GOOGLE: 'MaterialIcon',
  UPLOAD: 'Upload',
  UI_ASSET: 'UIAsset',
};

const propTypes = {
  ariaLabel: PropTypes.string,
  blockName: PropTypes.string,
  id: PropTypes.string, // legacy deprecated prop, use value instead
  iconSource: PropTypes.oneOf(Object.values(IconSource)),
  value: PropTypes.string,
};

const defaultProps = {
  ariaLabel: undefined,
  blockName: null,
  iconSource: IconSource.UI_ASSET,
  id: undefined,
  value: undefined,
};

function Icon(props) {
  const svgClasses = classNames(props.blockName, 'Icon');

  const iconSource = props.iconSource || IconSource.UI_ASSET;
  const value = props.value || props.id;

  const isDecorative = !props.ariaLabel;
  const ariaProps = isDecorative
    ? { 'aria-hidden': true }
    : { role: 'img', 'aria-label': props.ariaLabel };

  const sharedStyle = {
    userSelect: 'none',
  };

  if (iconSource === IconSource.GOOGLE) {
    return (
      <div
        className={`material-icons material-symbols-outlined ${svgClasses}`}
        {...ariaProps}
        style={sharedStyle}
      >
        {value}
      </div>
    );
  }

  if (iconSource === IconSource.UPLOAD) {
    return (
      <div
        className={`${svgClasses}`}
        {...ariaProps}
        style={{
          ...sharedStyle,
          backgroundColor: 'currentColor',
          maskImage: `url(${value})`,
          maskSize: 'contain',
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
          WebkitMaskImage: `url(${value})` /* Safari */,
          WebkitMaskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
        }}
      />
    );
  }

  // The legacy method of rendering an icon
  return (
    <svg className={svgClasses} {...ariaProps} focusable="false" style={sharedStyle}>
      <use href={`${ICON_SPRITE_PATH}#icon-${value}`} />
    </svg>
  );
}

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;
